module.exports = __webpack_public_path__ + "img/more_icon.b1f38da7.svg";